<template>
  <div class="container py-50">
    <div class="box-shadow p-30" v-if="loggedUser">
      <div class="row p-15 mb-30">
        <div class="col-md-9">
          <h1 class="">Your profile</h1>
        </div>
        <div class="col-md-3 text-right">
          <button class="btn btn-light-blue" v-if="!isEditMode" @click="setEditMode(true)">Edit</button>
          <button class="btn btn-secondary" v-if="isEditMode" @click="setEditMode(false)">Back</button>
        </div>
      </div>
      <div class="row p-15 px-60" v-if="!isEditMode">
        <div class="col-md-6">
          <data-item v-if="loggedUser.role.name == 'broker' || loggedUser.role.name == 'business' " label="Business Name">{{ loggedUser.first_name }}</data-item>
          <data-item v-else label="First Name">{{ loggedUser.first_name }}</data-item>
          <data-item label="Phone">{{ loggedUser.phone }}</data-item>
          <data-item v-if="loggedUser.legal_age" label="Over 18 years old"> Yes</data-item>
          <data-item v-else label="Over 18 years old">No</data-item>
          <data-item label="State">{{ loggedUser.state.name }}</data-item>
          <data-item label="Nearest Airport">{{ loggedUser.airport ? loggedUser.airport.name : "" }}</data-item>
        </div>
        <div class="col-md-6">
          <data-item v-if="!(loggedUser.role.name == 'broker') && !(loggedUser.role.name == 'business') " label="Last Name">{{ loggedUser.last_name }}</data-item>
          <data-item label="Email">{{ loggedUser.email }}</data-item>
          <data-item label="Address">{{ loggedUser.address_1 }}</data-item>
          <data-item label="City">{{ loggedUser.city }}</data-item>
          <data-item label="Zip code">{{ loggedUser.zip }}</data-item>
          <data-item v-if="loggedUser.role.name == 'broker' || loggedUser.role.name == 'business' " label="Contact Name">{{ loggedUser.contact_name }}</data-item>
        </div>
      </div>
      <div v-else class="row p-15 px-60">
        <div class="col-md-12">
          <business-form v-if="loggedUser.role.name == 'broker' || loggedUser.role.name == 'business' " :user="this.loggedUser" @saveUser="editProfile" button-text="Save changes" />
          <user-form v-else :user="this.loggedUser" @saveUser="editProfile" button-text="Save changes" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import httpClient from '@/utils/httpClient';
  import axios from "axios";
  import DataItem from "@/components/Shared/DataItem"
  import UserForm from "@/components/User/UserForm"
  import BusinessForm from "@/components/User/BusinessForm"

export default {
  components: {
    DataItem,
    UserForm,
    BusinessForm
  },
  data () {
    return {
      isEditMode: false
    }
  },
  computed: {
    loggedUser () {
      return this.$store.state.users.user
    }
  },
  methods: {
    getAllConversations() {
      axios.get("/api/conversations?include=trip.tripable,trip.to,trip.from").then(res => this.conversations = res.data.data.conversations);	
    },
    setEditMode (editMode) {
      this.isEditMode = editMode
    },
    editProfile (changedUser) {
      httpClient.patch("/api/user_profile", changedUser)
        .then(() => {
          this.$swal({ title:'Success!',icon:'success',text: "Your personal information has been updated!"})
          this.$store.dispatch('users/getUser')
            .then(() => {
              this.setEditMode(false)
            })
        })
        .catch((err) => {
          if (err.response.status == 422 && err.response.data && err.response.data.errors.errorField[0]) {
            this.$swal({ title:'Error',icon:'error',text: 'You must enter a valid '+err.response.data.errors.errorField[0]});
          }
          else {
            this.$swal({ title:'Error',icon:'error',text: "Something happened and we couldn't update your information."});
          }
        })
    }
  }
}
</script>

<style>

</style>